import api from '../../api';
import _ from 'lodash';
import router from '../../router';
import Vue from 'vue';

const state = {
	instance: null,
	progress: {
		load: false,
		store: false,
	},
	saved: false,
};

const getters = {

    isLoading: state => action => {
    	const target = state.target;
    	return _.get(state, `progress.${action}`, false);
    },

};

const actions = {

	updateInstance: function(context, payload) {
		context.commit('handleUpdateInstance', payload);
	},

	resetInstance: function(context, payload) {
		context.commit('handleResetInstance', payload);
	},

	edit: function (context, payload) {

		context.commit('handleLoadingStatus', { 
			action: 'load',
			status: true
		});

		// Get authenticated user's UUID from the auth module
		let user_uuid = context.rootState.auth.user;

		api.user.edit(user_uuid)
			.then((response) => {
				context.commit('handleEdit', response.data);
			})
			.catch((error) => {
				
			})
			.then(() => {
				context.commit('handleLoadingStatus', { 
					action: 'load',
					status: false
				});
			}); 

	},

	update: function (context, payload) {

		context.commit('handleLoadingStatus', { 
			action: 'store',
			status: true
		});
		context.commit('handleStatus', 'saving');

		// Get authenticated user's UUID from the auth module
		let user_uuid = context.rootState.auth.user;

		return api.user.update(user_uuid, payload)
			.then((response) => {
				context.commit('handleSaved', response.data);
				context.commit('handleStatus', 'saved');
			})
			.catch((error) => {
				
			})
			.then(() => {
				context.commit('handleLoadingStatus', { 
					action: 'store',
					status: false
				});
				context.commit('handleStatus', 'error');
			}); 
	},

};

const mutations = {

	handleLoadingStatus: function(state, {action, status}) {
		_.set(state, `progress.${action}`, status);
	},

	handleEdit: function (state, data) {
		_.set(state, `instance`, data);
	},

	handleSaved: function (state, data) {
		_.set(state, `instance`, data);
		
	},

	handleStatus: function(state, status) {
		_.set(state, 'status', status);
	},

	handleUpdateInstance: function (state, payload) {
		_.each(payload, (value,key) => {
			if (value == null) {
				_.unset(state, `instance.${key}`);	
			} else {
				_.set(state, `instance.${key}`, value);	
			}
		});
	},

	handleResetInstance: function (state, payload) {
		_.set(state, 'instance', {});
	},
};


export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}